import React, {PureComponent} from "react";
import {Col, Form, Row, Table} from "reactstrap";
import {withTranslation} from "react-i18next";
import {NotificationManager} from "../components/common/react-notifications";
import {i18nizeDate, numberWithCommas} from "../helpers/Utils";
import LoaderButton from "../components/LoaderButton";
import {Form as FinalForm} from "react-final-form";
import {getField} from "../helpers/core";
import {lowerCase, map} from "lodash";
import Rbac from "../components/Rbac";

class ScoreBoardDetails extends PureComponent {
  getInclusionFunctions = () => {
    const {t, board} = this.props;
    const {inclusionFunctions} = board;
    if (!inclusionFunctions || inclusionFunctions.length === 0) {
      return t("Does not exist");
    }
    return (
      <div>
        {map(inclusionFunctions, item => {
          const {name, params} = item;
          if (name === "UserRegisterTime") {
            const {time} = params;
            return (
              <div key={name} className="my-1">
                {t('Users who have registered after {{time}}', {
                  time: i18nizeDate(time),
                })}
              </div>
            );
          }
          if (name === "KycLimit") {
            const {limit} = params;
            return (
              <div key={name} className="my-1">
                {t('Users whose kyc level is at least {{limit}}', {
                  limit: numberWithCommas(limit),
                })}
              </div>
            );
          }
        })}
      </div>
    );
  };

  getScoreFunctions = () => {
    const {t, board} = this.props;
    const {scoreFunctions} = board;
    if (!scoreFunctions || scoreFunctions.length === 0) {
      return t("Does not exist");
    }
    return (
      <div>
        {map(scoreFunctions, item => {
          const {name, params, score} = item;
          if (name === "Simple") {
            return (
              <div key={name} className="my-1">
                {t('1 point per invited user')}
              </div>
            );
          }
          if (name === "KycLimitThreshold") {
            const {minLevel} = params;
            return (
              <div key={name} className="my-1">
                {t('{{score}} point(s) per invited user with min kyc level {{minLevel}}', {
                  score: numberWithCommas(score),
                  minLevel: numberWithCommas(minLevel)
                })}
              </div>
            );
          }
          if (name === "TradeThreshold") {
            const {minVol} = params;
            return (
              <div key={name} className="my-1">
                {t('{{score}} point(s) per invited user with minimum trade volume {{minVol}} TMN', {
                  score: numberWithCommas(score),
                  minVol: numberWithCommas(minVol)
                })}
              </div>
            );
          }
          if (name === "TradeStep") {
            const {step, since} = params;
            return (
              <div key={name} className="my-1">
                {t('{{score}} point(s) for every {{step}} TMN traded by invited users since {{since}}', {
                  score: numberWithCommas(score),
                  step: numberWithCommas(step),
                  since: i18nizeDate(since),
                })}
              </div>
            );
          }
          if (name === "Vol") {
            const {step} = params;
            return (
              <div key={name} className="my-1">
                {t('{{score}} point(s) for every {{step}} TMN trade', {
                  score: numberWithCommas(score),
                  step: numberWithCommas(step)
                })}
              </div>
            );
          }
          if (name === "Profit") {
            const {step} = params;
            return (
              <div key={name} className="my-1">
                {t('{{score}} point(s) for every {{step}} TMN profit', {
                  score: numberWithCommas(score),
                  step: numberWithCommas(step)
                })}
              </div>
            );
          }
        })}
      </div>
    );
  };

  getUpdatePeriod = () => {
    const {t, board} = this.props;
    const {updatePeriod} = board;
    const {type, period} = updatePeriod;
    if (type === "ONLINE") {
      return t("Realtime");
    }
    return t(lowerCase(period));
  };

  updateBoardSettings = async values => {
    const {t, board, updateBoard} = this.props;
    await updateBoard(board.id, {
      notifications: values,
    });
    NotificationManager.success(t('Board notification settings updated successfully'), t('Message'));
  };

  render() {
    const {t, board} = this.props;
    const {activityRange, maximumRank, notifications} = board;
    const {entered, exit, enterUpperLimit, exitUpperLimit, enterLowerLimit, exitLowerLimit, upperDisplacement, lowerDisplacement} = notifications;
    const {start, end, duration} = activityRange;
    return (
      <div className="table-row-sub d-flex flex-row p-2">
        <Table bordered responsive className="flex-1">
          <tbody>
            <tr>
              <td style={{width: 150}} className="text-info">{t('Board Activity Range')}</td>
              <td className="py-1">
                <div>
                  {!!start && <div className="my-1">{t("since {{time}} date", {time: i18nizeDate(start)})}</div>}
                  {!!duration && <div className="my-1">{t("From {{count}} days ago", {count: Number(duration)})}</div>}
                  {!!end && <div className="my-1">{t("until {{time}} date", {time: i18nizeDate(end)})}</div>}
                </div>
              </td>
            </tr>
            <tr>
              <td style={{width: 150}} className="text-info">{t('Inclusion Functions')}</td>
              <td className="py-1">{this.getInclusionFunctions()}</td>
            </tr>
            <tr>
              <td style={{width: 150}} className="text-info">{t('Score Functions')}</td>
              <td className="py-1">{this.getScoreFunctions()}</td>
            </tr>
            <tr>
              <td style={{width: 150}} className="text-info">{t('Board Update Period')}</td>
              <td className="py-1">{this.getUpdatePeriod()}</td>
            </tr>
            <tr>
              <td style={{width: 150}} className="text-info">{t('Board Max Ranking')}</td>
              <td className="py-1">{numberWithCommas(maximumRank)}</td>
            </tr>
            <tr>
              <td style={{width: 150}} className="text-info">{t('Notification')}</td>
              <td className="py-1">
                <div className="my-1">
                  {`${t('Send to board entered users')}:`}
                  <span className={`mx-2 ${entered ? "text-success" : "text-danger"}`}>
                    {entered ? t("Active") : t("Inactive")}
                  </span>
                </div>
                <div className="my-1">
                  {`${t('Send to board exited users')}:`}
                  <span className={`mx-2 ${exit ? "text-success" : "text-danger"}`}>
                    {exit ? t("Active") : t("Inactive")}
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </Table>
        <Rbac permission='update_boards'>
          <div style={{width: "50%", marginRight: 20}}>
            <FinalForm
              onSubmit={this.updateBoardSettings}
              initialValues={{
                ...(typeof enterUpperLimit === "number" ? {enterUpperLimit: String(enterUpperLimit)} : null),
                ...(typeof exitUpperLimit === "number" ? {exitUpperLimit: String(exitUpperLimit)} : null),
                ...(typeof enterLowerLimit === "number" ? {enterLowerLimit: String(enterLowerLimit)} : null),
                ...(typeof exitLowerLimit === "number" ? {exitLowerLimit: String(exitLowerLimit)} : null),
                ...(typeof upperDisplacement === "number" ? {upperDisplacement: String(upperDisplacement)} : null),
                ...(typeof lowerDisplacement === "number" ? {lowerDisplacement: String(lowerDisplacement)} : null)
              }}
              render={({handleSubmit, submitting, pristine, hasValidationErrors}) => {
                return (
                  <Form onSubmit={handleSubmit}>
                    <div className="text-medium text-info mb-4">
                      {t("Notification settings")}
                    </div>
                    <Row className="mb-2">
                      <Col className="col-12 col-xl-10">
                        {getField("int", {
                          name: 'enterUpperLimit',
                          label: t('Board enterUpperLimit notifications'),
                          required: false,
                        })}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col className="col-12 col-xl-10">
                        {getField("int", {
                          name: 'exitUpperLimit',
                          label: t('Board exitUpperLimit notifications'),
                          required: false,
                        })}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col className="col-12 col-xl-10">
                        {getField("int", {
                          name: 'enterLowerLimit',
                          label: t('Board enterLowerLimit notifications'),
                          required: false,
                        })}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col className="col-12 col-xl-10">
                        {getField("int", {
                          name: 'exitLowerLimit',
                          label: t('Board exitLowerLimit notifications'),
                          required: false,
                        })}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col className="col-12 col-xl-10">
                        {getField("int", {
                          name: 'upperDisplacement',
                          label: t('Board upperDisplacement notifications'),
                          required: false,
                        })}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col className="col-12 col-xl-10">
                        {getField("int", {
                          name: 'lowerDisplacement',
                          label: t('Board lowerDisplacement notifications'),
                          required: false,
                        })}
                      </Col>
                    </Row>
                    <LoaderButton
                      loading={submitting}
                      onClick={handleSubmit}
                      disabled={pristine || hasValidationErrors || submitting}
                      className="mt-3 text-center text-medium"
                      style={{minWidth: '100px'}}>
                      {t('Update')}
                    </LoaderButton>
                  </Form>
                );
              }}
            />
          </div>
        </Rbac>
      </div>
    );
  }
}

export default withTranslation()(ScoreBoardDetails);